export function createRolesFromBitMask(module: any, bitmask: any) {
  const moduleAuthorities = [];

  if (bitmask === 444) {
      moduleAuthorities.push(module);
      return moduleAuthorities;
  }

  // Bit 1 (0001) = visualizar
  if ((bitmask & 1) === 1) {
      moduleAuthorities.push(`${module}-visualizar`);
  }

  // Bit 2 (0010) = incluir  
  if ((bitmask & 2) === 2) {
      moduleAuthorities.push(`${module}-incluir`);
  }

  // Bit 4 (0100) = alterar
  if ((bitmask & 4) === 4) {
      moduleAuthorities.push(`${module}-alterar`);
  }

  // Bit 8 (1000) = excluir
  if ((bitmask & 8) === 8) {
      moduleAuthorities.push(`${module}-excluir`);
  }

  return moduleAuthorities;
}

export function convertCompressedToRoles(compressed: any) {
  const allRoles: any[] = [];
  
  Object.entries(compressed).forEach(([module, bitmask]) => {
    const moduleRoles = createRolesFromBitMask(module, bitmask);
    allRoles.push(...moduleRoles);
  });
  
  return allRoles;
}